import Users from "./Users";
import * as selectors from "./users.selectors";
import * as asyncActions from "./users.actions";
import * as slice from "./users.reducers";
import UserRoles from "./UserRoles";
import Invitations from "./Invitations";

export const {
  name,
  actions: { addUser, setSelectedUser, setSelectedUserRole, setUsersFilters, setInvitationFilters },
  reducer,
} = slice;

export const {
  saveUser,
  fetchUsers,
  deleteUser,
  updateUser,
  fetchUserRoles,
  deleteUserRole,
  createUserRole,
  updateUserRole,
  inviteUser,
  fetchUserSubscription,
  updateUserSubscription,
  fetchInvitations,
  updateInvitations,
} = asyncActions;

export const {
  selectUsers,
  selectUserRoles,
  selectSelectedUser,
  selectSelectedUserRole,
  selectTotalUsers,
  selectUsersFilters,
  selectInvitationsFilters,
  selectSubscription,
  selectAllInvitations,
  selectExistingInvitaion,
} = selectors;

export { Users, UserRoles,Invitations };
